<script setup lang="ts">
const { xlAndUp } = useLayout()
</script>

<template>
  <Header />
  <Sidebar>
    <slot name="sidebar" />
  </Sidebar>
  <main
    :class="
      cn('pl-0 pt-[--header-height] transition-all duration-300', {
        'pl-[--sidebar-width]': xlAndUp,
      })
    "
  >
    <slot />
  </main>
</template>
